module.exports = __webpack_public_path__ + "first-500_watermark.jpg?9a796868cb84631d23d3483695db99cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500_watermark.jpg
// module id = 565
// module chunks = 0